import { useEffect, useState } from "react";
import { imageSrc } from "../../lib/api";
import { hearts, loadHearts } from "../../lib/hearts";

// Heart counts are shown to visitors only here, quietly, beside each painting glimpse.
export function LovedStrip({ paintings }) {
  const [counts, setCounts] = useState(hearts.counts);
  useEffect(() => {
    loadHearts().then((h) => setCounts({ ...h.counts })).catch(() => {});
  }, []);
  const top = paintings.filter((p) => counts[p.id]).sort((a, b) => counts[b.id] - counts[a.id]).slice(0, 5);
  if (!top.length) return null;
  return (
    <ul data-testid="loved-strip" className="pointer-events-none absolute left-1/2 top-20 z-20 flex -translate-x-1/2 gap-3 rounded-full bg-[#FBF7F2]/90 px-4 py-2 shadow-md backdrop-blur-xl sm:top-24">
      {top.map((p) => (
        <li key={p.id} data-testid={`loved-glimpse-${p.slug}`} className="flex items-center gap-2">
          <img src={imageSrc(p.thumb_url || p.image_url)} alt="" className="h-9 w-9 rounded-md object-cover" />
          <span className="font-display text-base text-[#9B3B66]">♥ {counts[p.id]}</span>
        </li>
      ))}
    </ul>
  );
}
